const isComplexProduct = (
    product: unknown
): product is { sku: undefined; variants?: unknown[] } => {
    return (
        !!(product as { variants?: unknown[] }).variants &&
        (product as { variants: unknown[] }).variants.length > 0
    );
};

export default isComplexProduct;
